const UsersIcon = ({ className, fill }) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.4">
        <path
          d="M12.0003 3C8.50252 3 5.66699 5.83553 5.66699 9.33333C5.66699 12.8311 8.50252 15.6667 12.0003 15.6667C15.4981 15.6667 18.3337 12.8311 18.3337 9.33333C18.3337 5.83553 15.4981 3 12.0003 3Z"
          fill={fill || "#FF0000"}
        />
        <path
          d="M9.33366 17.6667C5.09948 17.6667 1.66699 21.0992 1.66699 25.3333C1.66699 27.3584 3.30861 29 5.33366 29H18.667C20.692 29 22.3337 27.3584 22.3337 25.3333C22.3337 21.0992 18.9012 17.6667 14.667 17.6667H9.33366Z"
          fill={fill || "#FF0000"}
        />
      </g>
      <path
        d="M20.0001 15.6667C19.2385 15.6667 18.5084 15.5323 17.832 15.2859C19.3756 13.7733 20.3334 11.6652 20.3334 9.33333C20.3334 7.00149 19.3756 4.89334 17.832 3.3808C18.5084 3.13441 19.2385 3 20.0001 3C23.4979 3 26.3334 5.83553 26.3334 9.33333C26.3334 12.8311 23.4979 15.6667 20.0001 15.6667Z"
        fill={fill || "#FF0000"}
      />
      <path
        d="M26.6661 29H22.9867C23.8262 28.0117 24.3327 26.7317 24.3327 25.3333C24.3327 22.2107 22.8521 19.4339 20.5547 17.6667H22.6661C26.9002 17.6667 30.3327 21.0992 30.3327 25.3333C30.3327 27.3584 28.6911 29 26.6661 29Z"
        fill={fill || "#FF0000"}
      />
    </svg>
  );
};

export default UsersIcon;
